module.exports = __webpack_public_path__ + "img/faq_cn.a45554a.jpg";